module.exports = __webpack_public_path__ + "static/media/filter.d23352db.svg";